<template>
    <div class="auth-container">
        <form @submit.prevent="login">
            <h1>Login</h1>
            <h4>Please sign in to continue</h4>
            <div class="form-group">
                <label>YOUR EMAIL</label>
                <input type="email" class="form-control auth-form-control" v-model="email" placeholder="user@example.com" autocomplete='chrome-off' required/>
            </div>
            <div v-if="wrong_credentials" style="color:red; text-transform: uppercase"> Wrong Credentials </div>
            <div class="form-group">
                <label>YOUR PASSWORD</label>
                <input type="password" class="form-control auth-form-control" v-model="password" placeholder="password" required/>
            </div>

            <button class="btn-auth">Login</button>
            
        </form>
        <div class="forgot-line"> 
            <a href="#">Forgot Password?</a>
        </div>
    </div>
    <div class="auth-footer">
            <span>Don't have an account? </span>
            <a href="/signup">Sign Up</a>
        </div>
</template>

<script>

import axios from 'axios'
export default {
    name: 'Login',
    data() {
        return {
            email: '' ,
            password: '',
            wrong_credentials: false
        }
    },
    methods: {
        login() {

            var formData = new FormData()

            formData.append('email', this.email)
            formData.append('password', this.password)
            
            axios.post(process.env.VUE_APP_BACK_URL + "/login", formData, {
                headers: { "Content-Type": "multipart/form-data" }
            }).then((response) => {
                if (response.data.code == 0){
                    this.$store.commit('changeId', response.data.user_id)
                    this.$store.commit('changeEmail', this.email)
                    this.$router.push('profile')
                } else if (response.data.code == -2){
                    this.wrong_credentials = true
                }
            }).catch((error) => {
                console.error(error)
            })
        },
        updateLoc() {
            this.$store.commit('changeLoc', false)
        }
    },
    mounted() {
        this.updateLoc()
    }
}    

</script>